import { getAttendancePartial } from './attendance'

export const getMe = `
{
    me {
        id
        first_name
        last_name
        email
        school_id
        higher_contrast
        a11y_mode
        role {
            id
            name
            display_name
            permissions {
                override
                reset_token
                create_participant
                assign_appointment
                create_appointment
                view_information
                access_reports
                cancellations
            }
        }
        tasks {
            id
            description
            taskable_id
            taskable_type
            created_at
            taskable {
                ... on Attendance {
                    student {
                        id
                        uuid
                    }
                    ${getAttendancePartial}
                }
            } 
        }
        tiles {
            id
            tileable_id
            tileable_type
            tileable {
                ... on Course {
                    id
                    uuid
                    title
                    attendance_last_class {
                        label
                        value
                    }
                }
                ... on Event {
                    id
                    uuid
                    title
                }
                ... on Team {
                    id
                    uuid
                    name
                    apa
                }
            }
        }
        assignedCourses {
            id
            title
        }
    }
}`

export const switchUser = `
    mutation switchUser($user_id: Int!) {
        switchUser(user_id: $user_id) {
            access_token
            search_token
        }
    }
`
